import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_FETCH_ASSETS,
} from '../../../../actions/actionTypes';
import { translate } from '../../../../helpers/languageHelper';

export default fetchReducerGenerator(
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_FETCH_ASSETS
);

export const getAllIncidentsAssetsResponse = state => {
  const { data } = state.response;
  return data ? data.map(({ assetId, name }) => ({ assetId, name })) : [];
};

export const getAllIncidentsAssetsResponseInternal = state => {
  const { data } = state.response;

  if (data) {
    const auditorAssets = data.filter(
      ({ auditOfAssetId }) => auditOfAssetId != null
    );
    const nonAuditorAssets = data.filter(
      ({ auditOfAssetId }) => auditOfAssetId == null
    );

    return [
      {
        group: translate('reporting.allIncidentsCustomer.filters.allAssets'),
        options: nonAuditorAssets.map(({ assetId, name }) => ({
          assetId,
          name,
        })),
      },
      {
        group: translate(
          'reporting.allIncidentsInternal.filters.auditorAssets'
        ),
        options: auditorAssets.map(({ assetId, name }) => ({ assetId, name })),
      },
    ];
  }
  return [];
};
